<template>
  <nav class="navbar">
    <div class="container">
      <!-- Logo and Title -->
      <div class="logo-title">
        <router-link to="/">
          <img class="logo-img" src="/icon.png" alt="htj">
        </router-link>
        <h1 class="site-title">How to Jeremy</h1>
      </div>

      <!-- Navigation Links -->
      <ul class="nav-links">
        <li>
          <router-link to="/" class="nav-link">Home</router-link>
        </li>
	<li>
          <a href="/portfolio" class="nav-link">Portfolio</a>
        </li>
        <li>
          <a href="/book/index.html" class="nav-link">Book</a>
        </li>
        <!--
        <li>
          <router-link to="/blog" class="nav-link">Blog</router-link>
        </li>
        -->
        <li>
          <a href="https://www.linkedin.com/in/jerschwartz/" class="icon-link" target="_blank">
            <font-awesome-icon :icon="['fab', 'linkedin']" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/howtojeremy/" class="icon-link" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>

      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>

<style scoped>
  /*#f97316;*/
  
.navbar {
  background-color: #ffac1c;
  color: white;
  padding: 1rem;
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.logo-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-img {
  height: 2.5rem;
  width: 2.5rem;
  padding: 0.25rem;
  background-color: white;
}

.site-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.nav-links {
  display: flex;
  list-style: none;
  padding: 0;
  gap: 1rem;
  margin-top: 0.5rem;
}

.nav-link {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-decoration: none;
  color: white;
  transition: background-color 0.2s ease;
}

.nav-link:hover {
  background-color: #fb923c;
}

.icon-link {
  color: white;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.icon-link:hover {
  opacity: 0.7;
}

.svg-inline--fa {
  width: 1rem;
  height: 1rem;
}  
</style>
